import type { WalletErrorType } from '../types';

export class BlockchainErrorParser {
  private static walletErrors: Record<string | number, string> = {
    [-32700]: "We couldn't process your request because it contains invalid JSON. Please check and try again.",
    [-32600]: 'Your request is not a valid JSON-RPC request. Please revise it.',
    [-32601]: 'The method you are trying to use does not exist. Please verify the method name.',
    [-32602]: 'The provided parameters are incorrect. Please double-check them.',
    [-32603]: 'An error occurred on our server. Please try again later.',
    [-32000]: 'Some parameters are missing or invalid. Please provide the correct data.',
    [-32001]: 'The resource you are looking for could not be found.',
    [-32002]: 'The requested resource is currently unavailable. Please try again later.',
    [-32003]: 'Your transaction was rejected. Please check its details and try again.',
    [-32004]: 'This method is not supported. Please refer to the documentation for supported methods.',
    [-32005]: 'Your request exceeds the allowed limits. Please reduce the load and try again.',
    [-32006]: 'The JSON-RPC version you are using is not supported.',
    [-1]: 'An unknown error occurred. Please try again later.',
    [4001]: 'You have rejected the transaction request in your wallet.',
    [4100]: 'You have not authorized the method or account. Please approve the request in your wallet.',
    [4200]: 'This method is not supported by your wallet provider.',
    [4900]: 'Your wallet is disconnected from all networks. Please reconnect.',
    [4901]: 'Your wallet is not connected to the specified chain. Please switch to the correct chain.',
    [4902]: 'An error occurred while switching chains. Please try again.',
    3: 'Sorry, but the Digital Original has already been sold to another collector. Please feel free to choose another piece.',
  };

  private static fallbackErrorMessage = 'An unexpected error occurred. Please contact us for assistance.';

  public static parse(error: WalletErrorType): string {
    try {
      const formattedError = this.extractErrorMessage(error);

      return formattedError || this.fallbackErrorMessage;
    } catch {
      return this.fallbackErrorMessage;
    }
  }

  private static extractErrorMessage(error: WalletErrorType): string | undefined {
    const cause = error?.cause;
    const nestedCause = cause?.cause;

    if (nestedCause && typeof nestedCause.code !== 'undefined') {
      return this.walletErrors[nestedCause.code];
    }

    if (error?.shortMessage) {
      return error.shortMessage;
    }

    if (error?.details) {
      return error.details;
    }

    return undefined;
  }
}
